module.exports = __webpack_public_path__ + "82f8cd63284fcb14b2a991f5e358f309.svg";